<template>
  <div id="pieChart" ref="chartContainer">
    <highcharts :options="chartData" ref="chart"></highcharts>
  </div>
</template>
<script>
export default {
  name: "pieChart",
  props: ["data"],
  data() {
    return {
      chartData: {},
      colorCodes: [
        "#47A694",
        "#54736D",
        "#265950",
        "#79A69E",
        "#317367",
        "#54736D",
        "#52BFAB",
        "#84B5AC",
        "#5F827C",
        "#388273",
        "#59CFB7",
      ]
    };
  },
  watch: {
    data: {
      deep: true,
      handler: function () {
        this.initiate();
      },
    },
  },
  mounted() {
    this.initiate();
    this.resizeObserver = new ResizeObserver(() => {
      this.resizeChart();
    });
    this.resizeObserver.observe(this.$refs.chartContainer);
  },
  beforeDestroy() {
    if (this.resizeObserver) {
      this.resizeObserver.disconnect();
    }
  },
  methods: {
    format(v) {
      return this.$options.filters.format(v);
    },
    resizeChart() {
      if (this.$refs.chart.chart) {
        this.$refs.chart.chart.reflow();
      }
    },
    initiate() {
      let self = this;
      let legendYaxis = 0
      if (!self.data.subtitle) {
        self.data.subtitle = {
          text: ""
        }
      } else {
        legendYaxis = -35
      }
      if (!self.data.marginTop) self.data.marginTop = 40
      self.chartData = {
        chart: {
          marginTop: 60,
          marginBottom: 20,
        },
        title: {
          text: '',
          verticalAlign: "bottom",
          style: { fontSize: 15, fontWeight: "600", color: "#01695C" },
        },
        exporting: {
          enabled: false,
        },
        tooltip: {
          formatter() {
            var mytooltip = "";
            // mytooltip +=
            //   '<span style="font-size:22px;color:' +
            //   this.point.color +
            //   '">\u25CF</span> ';
            mytooltip += '<span style="color:white;  font-weight:400; font-size:14px;  text-transform:capitalize;">';
            mytooltip += this.point.name + " : <b> ";
            mytooltip += '</span>';
            mytooltip += '<span style="color:white; font-weight:400; font-size:14px;">';
            mytooltip += self.format(this.point.y) + "%";
            mytooltip += '</span>';
            return mytooltip;
          },
          shared: true,
          useHTML: true,
          borderWidth: 0,
          shadow: {
            color: "rgba(0, 0, 0, 0.25)",
            opacity: 0.1,
            width: 10,
          },
          borderRadius: 10,
          backgroundColor: "#065559",
          padding: 12,
        },
        credits: {
          enabled: false,
        },
        accessibility: {
          point: {
            valueSuffix: '%'
          }
        },
        plotOptions: {
          pie: {
            dataLabels: {
              enabled: false,
              useHTML: true,
              formatter: function () {
                self.pieTotal = this.point.total;

                return (
                  '<span style="color:white;font-size:12px;font-weight:normal;">' +
                  self.format(this.point.percentage.toFixed()) +
                  "%</span>"
                );
              },
              distance: -13,
              style: {
                fontSize: 11,
              },
            },
            showInLegend: true,
            size: "100%",
          },
        },
        legend: {
          alignColumns: true,
          align: "right",
          y: 0,
          x: 0,
          squareSymbol: true,
          verticalAlign: "top",
          itemDistance: 35,
          margin: 0,
          padding: 0,
          symbolHeight: 14,
          symbolWidth: 14,
          symbolRadius: 10,
          itemStyle: {
            fontFamily: 'Poppins',
            fontWeight: 600,
            color: "#a1a1a1",
            fontSize: "14px",
            letterSpacing: '.5px',
            textTransform: "capitalize",
          },
          itemHoverStyle: {
            color: '#065559', // Hover color
          },
        },
        series: [
          {
            type: "pie",
            // innerSize: "50%",
            data: this.data,
          },
        ],
      };
    },
  },
};
</script>

<style scoped></style>
